export const BorderRadiusExtraSmall = "2px";
export const BorderRadiusSmall = "4px";
export const BorderRadiusMedium = "8px";
export const BorderRadiusLarge = "16px";
export const BorderWidthSmall = "1px";
export const BorderWidthMedium = "2px";
export const BorderWidthLarge = "4px";
export const BorderDefault = "1px solid var(--color-neutral-grey-4)";
export const BorderSecondary = "1px solid var(--color-neutral-grey-3)";
export const ColorNeutralBlack = "var(--color-neutral-black)";
export const ColorNeutralDarkGrey = "var(--color-neutral-dark-grey)";
export const ColorNeutralLightGrey = "var(--color-neutral-light-grey)";
export const ColorNeutralWhite = "var(--color-neutral-white)";
export const ColorNeutralGrey1 = "var(--color-neutral-grey-1)";
export const ColorNeutralGrey2 = "var(--color-neutral-grey-2)";
export const ColorNeutralGrey3 = "var(--color-neutral-grey-3)";
export const ColorNeutralGrey4 = "var(--color-neutral-grey-4)";
export const ColorNeutralGrey5 = "var(--color-neutral-grey-5)";
export const ColorBrandBlue1 = "var(--color-brand-blue-1)";
export const ColorBrandBlue2 = "var(--color-brand-blue-2)";
export const ColorBrandBlue3 = "var(--color-brand-blue-3)";
export const ColorBrandBlue4 = "var(--color-brand-blue-4)";
export const ColorBrandBlue5 = "var(--color-brand-blue-5)";
export const ColorBrandBlueBase = "var(--color-brand-blue-base)";
export const ColorBrandBlueActivated = "var(--color-brand-blue-activated)";
export const ColorBrandBlueFocus = "var(--color-brand-blue-focus)";
export const ColorBrandBlueHover = "var(--color-brand-blue-hover)";
export const ColorBrandBluePressed = "var(--color-brand-blue-pressed)";
export const ColorBrandBlueReadonly = "var(--color-brand-blue-readonly)";
export const ColorBrandBlueSelected = "var(--color-brand-blue-selected)";
export const ColorNordicGrey1 = "var(--color-nordic-grey-1)";
export const ColorNordicGrey2 = "var(--color-nordic-grey-2)";
export const ColorNordicGrey3 = "var(--color-nordic-grey-3)";
export const ColorNordicGrey4 = "var(--color-nordic-grey-4)";
export const ColorNordicGrey5 = "var(--color-nordic-grey-5)";
export const ColorNordicGreyBase = "var(--color-nordic-grey-base)";
export const ColorNordicGreyActivated = "var(--color-nordic-grey-activated)";
export const ColorNordicGreyFocus = "var(--color-nordic-grey-focus)";
export const ColorNordicGreyHover = "var(--color-nordic-grey-hover)";
export const ColorNordicGreyPressed = "var(--color-nordic-grey-pressed)";
export const ColorNordicGreyReadonly = "var(--color-nordic-grey-readonly)";
export const ColorNordicGreySelected = "var(--color-nordic-grey-selected)";
export const ColorClubMatas1 = "var(--color-club-matas-1)";
export const ColorClubMatas2 = "var(--color-club-matas-2)";
export const ColorClubMatas3 = "var(--color-club-matas-3)";
export const ColorClubMatas4 = "var(--color-club-matas-4)";
export const ColorClubMatas5 = "var(--color-club-matas-5)";
export const ColorClubMatasBase = "var(--color-club-matas-base)";
export const ColorClubMatasActivated = "var(--color-club-matas-activated)";
export const ColorClubMatasFocus = "var(--color-club-matas-focus)";
export const ColorClubMatasHover = "var(--color-club-matas-hover)";
export const ColorClubMatasPressed = "var(--color-club-matas-pressed)";
export const ColorClubMatasReadonly = "var(--color-club-matas-readonly)";
export const ColorClubMatasSelected = "var(--color-club-matas-selected)";
export const ColorClubMatasPlus1 = "var(--color-club-matas-plus-1)";
export const ColorClubMatasPlus2 = "var(--color-club-matas-plus-2)";
export const ColorClubMatasPlus3 = "var(--color-club-matas-plus-3)";
export const ColorClubMatasPlus4 = "var(--color-club-matas-plus-4)";
export const ColorClubMatasPlus5 = "var(--color-club-matas-plus-5)";
export const ColorClubMatasPlusBase = "var(--color-club-matas-plus-base)";
export const ColorClubMatasPlusActivated =
  "var(--color-club-matas-plus-activated)";
export const ColorClubMatasPlusFocus = "var(--color-club-matas-plus-focus)";
export const ColorClubMatasPlusHover = "var(--color-club-matas-plus-hover)";
export const ColorClubMatasPlusPressed = "var(--color-club-matas-plus-pressed)";
export const ColorClubMatasPlusReadonly =
  "var(--color-club-matas-plus-readonly)";
export const ColorClubMatasPlusSelected =
  "var(--color-club-matas-plus-selected)";
export const ColorAdvice1 = "var(--color-advice-1)";
export const ColorAdvice2 = "var(--color-advice-2)";
export const ColorAdvice3 = "var(--color-advice-3)";
export const ColorAdvice4 = "var(--color-advice-4)";
export const ColorAdvice5 = "var(--color-advice-5)";
export const ColorSubscription1 = "var(--color-subscription-1)";
export const ColorSubscription2 = "var(--color-subscription-2)";
export const ColorSubscription3 = "var(--color-subscription-3)";
export const ColorSubscription4 = "var(--color-subscription-4)";
export const ColorSubscription5 = "var(--color-subscription-5)";
export const ColorSubscriptionBase = "var(--color-subscription-base)";
export const ColorSubscriptionActivated = "var(--color-subscription-activated)";
export const ColorSubscriptionFocus = "var(--color-subscription-focus)";
export const ColorSubscriptionHover = "var(--color-subscription-hover)";
export const ColorSubscriptionPressed = "var(--color-subscription-pressed)";
export const ColorSubscriptionReadonly = "var(--color-subscription-readonly)";
export const ColorSubscriptionSelected = "var(--color-subscription-selected)";
export const ColorSpot1 = "var(--color-spot-1)";
export const ColorSpot2 = "var(--color-spot-2)";
export const ColorSpot3 = "var(--color-spot-3)";
export const ColorSpot4 = "var(--color-spot-4)";
export const ColorSpot5 = "var(--color-spot-5)";
export const ColorFixed1 = "var(--color-fixed-1)";
export const ColorFixed2 = "var(--color-fixed-2)";
export const ColorFixed3 = "var(--color-fixed-3)";
export const ColorFixed4 = "var(--color-fixed-4)";
export const ColorFixed5 = "var(--color-fixed-5)";
export const ColorBeauty1 = "var(--color-beauty-1)";
export const ColorBeauty2 = "var(--color-beauty-2)";
export const ColorBeauty3 = "var(--color-beauty-3)";
export const ColorBeauty4 = "var(--color-beauty-4)";
export const ColorBeauty5 = "var(--color-beauty-5)";
export const ColorBeautyBase = "var(--color-beauty-base)";
export const ColorBeautyActivated = "var(--color-beauty-activated)";
export const ColorBeautyFocus = "var(--color-beauty-focus)";
export const ColorBeautyHover = "var(--color-beauty-hover)";
export const ColorBeautyPressed = "var(--color-beauty-pressed)";
export const ColorBeautyReadonly = "var(--color-beauty-readonly)";
export const ColorBeautySelected = "var(--color-beauty-selected)";
export const ColorSkin1 = "var(--color-skin-1)";
export const ColorSkin2 = "var(--color-skin-2)";
export const ColorSkin3 = "var(--color-skin-3)";
export const ColorSkin4 = "var(--color-skin-4)";
export const ColorSkin5 = "var(--color-skin-5)";
export const ColorMen1 = "var(--color-men-1)";
export const ColorMen2 = "var(--color-men-2)";
export const ColorMen3 = "var(--color-men-3)";
export const ColorMen4 = "var(--color-men-4)";
export const ColorMen5 = "var(--color-men-5)";
export const ColorHair1 = "var(--color-hair-1)";
export const ColorHair2 = "var(--color-hair-2)";
export const ColorHair3 = "var(--color-hair-3)";
export const ColorHair4 = "var(--color-hair-4)";
export const ColorHair5 = "var(--color-hair-5)";
export const ColorHealth1 = "var(--color-health-1)";
export const ColorHealth2 = "var(--color-health-2)";
export const ColorHealth3 = "var(--color-health-3)";
export const ColorHealth4 = "var(--color-health-4)";
export const ColorHealth5 = "var(--color-health-5)";
export const ColorFragrance1 = "var(--color-fragrance-1)";
export const ColorFragrance2 = "var(--color-fragrance-2)";
export const ColorFragrance3 = "var(--color-fragrance-3)";
export const ColorFragrance4 = "var(--color-fragrance-4)";
export const ColorFragrance5 = "var(--color-fragrance-5)";
export const ColorMedicine1 = "var(--color-medicine-1)";
export const ColorMedicine2 = "var(--color-medicine-2)";
export const ColorMedicine3 = "var(--color-medicine-3)";
export const ColorMedicine4 = "var(--color-medicine-4)";
export const ColorMedicine5 = "var(--color-medicine-5)";
export const ColorSystemPositive1 = "var(--color-system-positive-1)";
export const ColorSystemPositive2 = "var(--color-system-positive-2)";
export const ColorSystemPositive3 = "var(--color-system-positive-3)";
export const ColorSystemPositive4 = "var(--color-system-positive-4)";
export const ColorSystemPositive5 = "var(--color-system-positive-5)";
export const ColorSystemNegative1 = "var(--color-system-negative-1)";
export const ColorSystemNegative2 = "var(--color-system-negative-2)";
export const ColorSystemNegative3 = "var(--color-system-negative-3)";
export const ColorSystemNegative4 = "var(--color-system-negative-4)";
export const ColorSystemNegative5 = "var(--color-system-negative-5)";
export const ColorSystemAttention1 = "var(--color-system-attention-1)";
export const ColorSystemAttention2 = "var(--color-system-attention-2)";
export const ColorSystemAttention3 = "var(--color-system-attention-3)";
export const ColorSystemAttention4 = "var(--color-system-attention-4)";
export const ColorSystemAttention5 = "var(--color-system-attention-5)";
export const ColorOpacityDark1 = "var(--color-opacity-dark-1)";
export const ColorOpacityDark2 = "var(--color-opacity-dark-2)";
export const ColorOpacityDark3 = "var(--color-opacity-dark-3)";
export const ColorOpacityDark4 = "var(--color-opacity-dark-4)";
export const ColorOpacityDark5 = "var(--color-opacity-dark-5)";
export const ColorOpacityLight1 = "var(--color-opacity-light-1)";
export const ColorOpacityLight2 = "var(--color-opacity-light-2)";
export const ColorOpacityLight3 = "var(--color-opacity-light-3)";
export const ColorOpacityLight4 = "var(--color-opacity-light-4)";
export const ColorOpacityLight5 = "var(--color-opacity-light-5)";
export const ColorOpacityOnDarkHover = "var(--color-opacity-on-dark-hover)";
export const ColorOpacityOnDarkFocus = "var(--color-opacity-on-dark-focus)";
export const ColorOpacityOnDarkSelected =
  "var(--color-opacity-on-dark-selected)";
export const ColorOpacityOnDarkActivated =
  "var(--color-opacity-on-dark-activated)";
export const ColorOpacityOnDarkPressed = "var(--color-opacity-on-dark-pressed)";
export const ColorOpacityOnLightHover = "var(--color-opacity-on-light-hover)";
export const ColorOpacityOnLightFocus = "var(--color-opacity-on-light-focus)";
export const ColorOpacityOnLightSelected =
  "var(--color-opacity-on-light-selected)";
export const ColorOpacityOnLightActivated =
  "var(--color-opacity-on-light-activated)";
export const ColorOpacityOnLightPressed =
  "var(--color-opacity-on-light-pressed)";
export const ColorFocusStateBorderOnLight =
  "var(--color-focus-state-border-on-light)";
export const ColorFocusStateBorderOnDark =
  "var(--color-focus-state-border-on-dark)";
export const ColorWhiteBase = "var(--color-white-base)";
export const ColorWhiteHover = "var(--color-white-hover)";
export const ColorWhiteFocus = "var(--color-white-focus)";
export const ColorWhiteSelected = "var(--color-white-selected)";
export const ColorWhiteActivated = "var(--color-white-activated)";
export const ColorWhitePressed = "var(--color-white-pressed)";
export const ColorWhiteReadonly = "var(--color-white-readonly)";
export const ColorFavorite = "var(--color-favorite)";
export const ColorCtaSecondary1 = "var(--color-cta-secondary-1)";
export const ColorCtaSecondary2 = "var(--color-cta-secondary-2)";
export const ColorCtaSecondary3 = "var(--color-cta-secondary-3)";
export const ColorCtaSecondary4 = "var(--color-cta-secondary-4)";
export const ColorCtaSecondary5 = "var(--color-cta-secondary-5)";
export const ColorCtaSecondaryBase = "--color-cta-secondary-base";
export const ColorCtaSecondaryActivated = "--color-cta-secondary-activated";
export const ColorCtaSecondaryFocus = "--color-cta-secondary-focus";
export const ColorCtaSecondaryHover = "--color-cta-secondary-hover";
export const ColorCtaSecondaryPressed = "--color-cta-secondary-pressed";
export const ColorCtaSecondaryReadonly = "--color-cta-secondary-readonly";
export const ColorCtaSecondarySelected = "--color-cta-secondary-selected";
export const ColorMenuButton1 = "color--menu-button-1";
export const ColorMenuButton2 = "color--menu-button-2";
export const ColorMenuButton3 = "color--menu-button-3";
export const ColorMenuButton4 = "color--menu-button-4";
export const ColorMenuButton5 = "color--menu-button-5";
export const ColorMenuButtonBase = "color--menu-button-base";
export const ColorMenuButtonActivated = "color--menu-button-activated";
export const ColorMenuButtonFocus = "color--menu-button-focus";
export const ColorMenuButtonHover = "color--menu-button-hover";
export const ColorMenuButtonPressed = "color--menu-button-pressed";
export const ColorMenuButtonReadonly = "color--menu-button-readonly";
export const ColorMenuButtonSelected = "color--menu-button-selected";
export const ColorBackgroundMenu = "var(--color-background-menu)";
export const FontHeading1FamilySansSerif = "var(--font-font-family-primary)";
export const FontHeading1FamilySerif = "var(--font-font-family-secondary)";
export const FontHeading1Size = "2.5000rem";
export const FontHeading1LineHeight = 1.05;
export const FontHeading1WeightSemiBold = 600;
export const FontHeading1WeightRegular = 400;
export const FontHeading2FamilySansSerif = "var(--font-font-family-primary)";
export const FontHeading2FamilySerif = "var(--font-font-family-secondary)";
export const FontHeading2Size = "2.0000rem";
export const FontHeading2LineHeight = 1.3125;
export const FontHeading2WeightSemiBold = 600;
export const FontHeading2WeightRegular = 400;
export const FontHeading3FamilySansSerif = "var(--font-font-family-primary)";
export const FontHeading3FamilySerif = "var(--font-font-family-secondary)";
export const FontHeading3Size = "1.5000rem";
export const FontHeading3LineHeightSansSerifSemiBold = 1;
export const FontHeading3LineHeightSerifRegular = 1.3333;
export const FontHeading3WeightSemiBold = 600;
export const FontHeading3WeightRegular = 400;
export const FontHeading4Size = "1.0000rem";
export const FontHeading4LineHeight = 1.5;
export const FontHeading4FamilySansSerif = "var(--font-font-family-primary)";
export const FontHeading4FamilySerif = "var(--font-font-family-secondary)";
export const FontHeading4WeightRegular = 400;
export const FontHeading4WeightSemiBold = 600;
export const FontBody1Family = "var(--font-font-family-primary)";
export const FontBody1Size = "1.0000rem";
export const FontBody1LineHeight = 1.5;
export const FontBody1WeightLight = 300;
export const FontBody1WeightRegular = 400;
export const FontBody1WeightSemiBold = 600;
export const FontBody2Family = "var(--font-font-family-primary)";
export const FontBody2SizeSmall = "0.8125rem";
export const FontBody2SizeLarge = "0.8750rem";
export const FontBody2LineHeightSmall = 1.2308;
export const FontBody2LineHeightLarge = 1.2143;
export const FontBody2WeightLight = 300;
export const FontBody2WeightRegular = 400;
export const FontBody2WeightSemiBold = 600;
export const FontButtonFamily = "var(--font-font-family-primary)";
export const FontButtonSizeSmall = "0.8125rem";
export const FontButtonSizeLarge = "1.0000rem";
export const FontButtonLineHeight = 1;
export const FontButtonWeightRegular = 400;
export const FontButtonWeightSemiBold = 600;
export const FontLeadParagraphFamily = "var(--font-font-family-secondary)";
export const FontLeadParagraphSize = "1.0000rem";
export const FontLeadParagraphLineHeight = 1.5;
export const FontLeadParagraphWeight = 400;
export const FontOverlineFamily = "var(--font-font-family-primary)";
export const FontOverlineSizeLarge = "0.7500rem";
export const FontOverlineSizeSmall = "0.6250rem";
export const FontOverlineLetterSpacing = "1px";
export const FontOverlineLineHeight = 1;
export const FontOverlineWeight = 400;
export const FontOverlineTextTransform = "uppercase";
export const FontCaptionFamily = "var(--font-font-family-primary)";
export const FontCaptionSizeSmall = "0.5000rem";
export const FontCaptionSizeMedium = "0.6250rem";
export const FontCaptionSizeLarge = "0.7500rem";
export const FontCaptionLineHeightSmall = 1.25;
export const FontCaptionLineHeightMedium = 1.4;
export const FontCaptionLineHeightLarge = 1.3333;
export const FontCaptionWeightLight = 300;
export const FontCaptionWeightRegular = 400;
export const FontCaptionWeightSemiBold = 600;
export const FontLabelFamily = "var(--font-font-family-primary)";
export const FontLabelSizeSmall = "0.8750rem";
export const FontLabelSizeLarge = "1.0000rem";
export const FontLabelLineHeight = 1;
export const FontLabelWeightRegular = 400;
export const FontLabelWeightSemiBold = 600;
export const FontSize8 = "0.5714rem";
export const FontSize10 = "0.7143rem";
export const FontSize12 = "0.8571rem";
export const FontSize14 = "1.0000rem";
export const FontSize16 = "1.1429rem";
export const FontSize18 = "1.2857rem";
export const FontSize20 = "1.4286rem";
export const FontSize24 = "1.7143rem";
export const FontSize28 = "2.0000rem";
export const FontSize32 = "2.2857rem";
export const FontSize40 = "2.8571rem";
export const FontSize48 = "3.4286rem";
export const FontSize56 = "4.0000rem";
export const FontWeightNormal = 400;
export const FontWeightSemiBold = 600;
export const FontLineHeightNone = 1;
export const FontLineHeightTight = 1.2;
export const FontLineHeightNormal = 1.5;
export const FontLetterSpacing04 = "0.04em";
export const FontFontFamilyPrimary = "var(--font-font-family-primary)";
export const FontFontFamilySecondary = "var(--font-font-family-secondary)";
export const BoxShadowSmall = "0px 2px 6px rgba(0,0,0,0.08)";
export const BoxShadowMedium = "0px 4px 6px rgba(0,0,0,0.08)";
export const BoxShadowLarge = "0px 6px 6px rgba(0,0,0,0.08)";
export const BoxShadowXl = "0px 8px 6px rgba(0,0,0,0.08)";
export const Spacing2 = "2px";
export const Spacing4 = "4px";
export const Spacing6 = "6px";
export const Spacing8 = "8px";
export const Spacing12 = "12px";
export const Spacing16 = "16px";
export const Spacing20 = "20px";
export const Spacing24 = "24px";
export const Spacing28 = "28px";
export const Spacing32 = "32px";
export const Spacing40 = "40px";
export const Spacing48 = "48px";
export const Spacing56 = "56px";
export const Spacing64 = "64px";
export const Spacing72 = "72px";
export const Spacing80 = "80px";
export const Spacing88 = "88px";
export const Spacing96 = "96px";
export const Spacing104 = "104px";
export const Spacing112 = "112px";
export const Spacing120 = "120px";
